import { useApiStore } from "@/stores/api/index.ts";

const fetchSiteSwitcherSites = async (module) => {
  const api = useApiStore();
  const { commit, rootGetters, getters } = module;

  if (rootGetters.getIsInternal) {
    return getters.siteSwitcherSites();
  }

  const siteDataPromises = rootGetters.getSiteIds.map((siteId) =>
    api.fetchStylingData(siteId)
  );

  const siteDataResults = await Promise.all(siteDataPromises);

  commit(
    "storeSiteSwitcherSites",
    siteDataResults.map((result) => result.data)
  );

  return getters.siteSwitcherSites();
};

export { fetchSiteSwitcherSites };
